// This follows the same pattern that we use with deprecated-color.less.
export enum Color {
  Disabled = '#c3c1c1',
  Error = '#d13c3c',
  Success = '#55bd55',
}
